const contact_us_text = `We are accepting new clients on a referral basis only.  If our contact information has been shared with you by a friend or colleague we look forward to hearing from you.`;
export default contact_us_text;
